"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var Heartbeat = /** @class */ (function () {
    function Heartbeat(heartbeatOption) {
        if (heartbeatOption === void 0) { heartbeatOption = { outgoing: 10000, incoming: 10000 }; }
        var _this = this;
        // Heart-beat negotiation
        this.startHeartbeat = function (serverOutgoing, serverIncoming, callback) {
            _this.stopHeartbeat();
            // heart-beat header received from the server looks like:
            //
            //     heart-beat: sx, sy
            if (!(_this.heartbeatSettings.outgoing === 0 || serverIncoming === 0)) {
                var ttl = Math.min(_this.heartbeatSettings.outgoing, serverIncoming);
                _this._startPinger(ttl, callback.sendPing);
            }
            if (!(_this.heartbeatSettings.incoming === 0 || serverOutgoing === 0)) {
                var ttl = Math.min(_this.heartbeatSettings.incoming, serverOutgoing);
                _this._startPonger(ttl, callback.close);
            }
        };
        this.stopHeartbeat = function () {
            clearInterval(_this.pinger);
            clearInterval(_this.ponger);
        };
        this.activityFromServer = function () {
            _this.lastServerActivity = Date.now();
        };
        this._startPinger = function (ttl, sendPing) {
            utils_1.logger.debug("send PING every " + ttl + "ms");
            _this.pinger = setInterval(function () {
                sendPing();
                utils_1.logger.debug('>>> PING');
            }, ttl);
        };
        this._startPonger = function (ttl, close) {
            utils_1.logger.debug("check PONG every " + ttl + "ms");
            _this.lastServerActivity = Date.now();
            _this.ponger = setInterval(function () {
                var delta = Date.now() - _this.lastServerActivity;
                // We wait twice the TTL to be flexible on window's setInterval calls
                if (delta > ttl * 2) {
                    utils_1.logger.debug("did not receive server activity for the last " + delta + "ms");
                    close();
                }
            }, ttl);
        };
        this.heartbeatSettings = heartbeatOption || { outgoing: 0, incoming: 0 };
    }
    return Heartbeat;
}());
exports.default = Heartbeat;
